import React from 'react';
import { motion } from 'framer-motion';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const showcaseContent = {
  title: 'Un vistazo al material que te llevás',
  subtitle: 'Fichas, registros, recursos visuales y plantillas listas para imprimir y aplicar.',
  // Podés reemplazar estas imágenes por capturas reales de tu material
  images: [{
    url: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=800&auto=format&fit=crop',
    caption: 'Fichas de observación clínica'
  }, {
    url: 'https://images.unsplash.com/photo-1587145820266-a5951ee6f620?q=80&w=800&auto=format&fit=crop',
    caption: 'Recursos visuales para sesiones'
  }, {
    url: 'https://images.unsplash.com/photo-1607453998774-d533f65dac99?q=80&w=800&auto=format&fit=crop',
    caption: 'Material para familias'
  }, {
    url: 'https://images.unsplash.com/photo-1602052793312-b99c2a9ee797?q=80&w=800&auto=format&fit=crop',
    caption: 'Actividades sensoriales'
  }]
};
export function Showcase() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-4 text-brand-light" data-id="element-196">
            {showcaseContent.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-light/70 font-sans max-w-2xl mx-auto" data-id="element-197">
            {showcaseContent.subtitle}
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-198">
          {showcaseContent.images.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative overflow-hidden rounded-2xl border border-brand-cardBorder aspect-[3/4]" data-id="element-199">
              <img src={image.url} alt={image.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-200" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/40 to-transparent" data-id="element-201" />
              <div className="absolute bottom-4 left-4 right-4" data-id="element-202">
                <p className="text-sm font-sans text-brand-light/90 font-medium" data-id="element-203">
                  {image.caption}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}